import React, { useMemo } from 'react';
import classNames from 'classnames';
import { faChartBar } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col } from 'reactstrap';
import { Link } from 'react-router-dom';

const colBreakpoints = { lg: '3', md: '6', xs: '12' };
const linkStyle = { textDecoration: 'none', color: 'white' };
const dashTabClass = 'p-2 text-center sc-rounded hide-overflow sc-glass';

function DashboardTab({ url }) {
    const dashTabClasses = useMemo(
        () =>
            classNames(dashTabClass, {
                'bg-light text-dark': url === '/',
            }),
        [url]
    );
    return (
        <Col {...colBreakpoints} className="p-1">
            <Link to="/" style={linkStyle}>
                <div className={dashTabClasses}>
                    Dashboard&emsp;
                    <FontAwesomeIcon size="lg" icon={faChartBar} />
                </div>
            </Link>
        </Col>
    );
}

export default DashboardTab;
